import React from 'react'
import { WrappedFieldMetaProps } from 'redux-form'
import { useErrorLaunder } from './useErrorLaunder'

type Props = WrappedFieldMetaProps
export const useFieldError = ({ touched, invalid, error }: Props) => {
  const errorText = useErrorLaunder(error)

  return React.useMemo(() => ({ isError: touched && invalid, errorText: touched && errorText }), [touched, invalid, error])
}
